// extracted by mini-css-extract-plugin
module.exports = {"image":"RelatedPublications_image__3_J0f"};